export default __webpack_public_path__ + "static/media/2503282.ce91678f.jpg";